import {IItemUiEnv} from "/@back@/wsp/views/itemMain.js";
import {IReg, REG} from "/@lib@/commons/registry.js";
import {JSX} from "/@lib@/commons/xml/dom.js";
import {ItemDynGen, OItemDynGenInit} from "/@back@/wsp/views/item/itemDynGen.js";
import {SRC} from "/@lib@/wsp/src.js";
import {TASK} from "/@lib@/wsp/lcTask.js";

/**
 * View d'une tâche via un dynGen.
 *
 * Config attributes:
 */
export interface TaskDynGen extends ItemDynGen {
	initialize(init: OTaskDynGenInit): this;
}

export interface OTaskDynGenInit extends OItemDynGenInit {
}

export class TaskDynGen extends ItemDynGen {
	reg: IReg<IItemUiEnv>;

	_initialize(init: OTaskDynGenInit) {
		init.skin = "wsp-task-dyngen";
		if (!init.toolbar) init.toolbar = false;
		if (init.autoResize === undefined) init.autoResize = true;
		super._initialize(init);
	}

	connectedCallback() {
		super.connectedCallback();
		if (SRC.isNewSrcUri(this.reg.env.longDesc.srcUri)) {
			TASK.hideContextField(this, true);
		}
	}
}

customElements.define("wsp-task-dyngen", TaskDynGen);

REG.reg.registerSkin("wsp-task-dyngen", 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		overflow: auto;
	}
`);
